<template>
  <main class="cast container">
    <div class="row">
      <div class="col">
        <cast-live></cast-live>
      </div>
    </div>
  </main>
</template>

<style scoped>
.chat-thread {
  height: 25rem;
}
</style>

<script>
import CastLive from '@/components/live/CastLive'
import ChatThread from '@/components/chat/ChatThread'
import ChatInput from '@/components/chat/ChatInput'
// import l from '@/vendor/logger'

export default {
  name: 'Cast',

  created () {
    this.$store.commit('room/setRoomType', 'CAST')
  },

  mounted () {
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  data () {
    return {}
  },

  computed: {
  },

  methods: {
    unbind () {
      this.$store.dispatch('room/unbindRoom')
    }
  },

  components: {
    CastLive,
    ChatThread,
    ChatInput
  }
}
</script>
